
import Vue from 'vue'
import Component from 'vue-class-component'
import { INotificationService } from '../services/NotificationService'
import UserService from '../services/UserService'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import GreenButton from '../components/Atomic/GreenButton.vue'
import RedButton from '../components/Atomic/RedButton.vue'
import Login from '@/views/Login.vue'
import LoginRecoveryHelpCard from '@/components/LoginRecoveryHelpCard.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    LoginRecoveryHelpCard,
    Login,
    GreenButton,
    RedButton,
    CardTitle,
    ProgressLinear,
  },
})
export default class RecoverUsername extends Vue {
  private email: string = ''
  private isPending: boolean = false
  private $notificationService: INotificationService = {} as any
  private errorHandlerService: ErrorHandlerService

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  private async send() {
    this.isPending = true

    const validated = await this.$validator.validateAll()
    if (validated) {
      try {
        const response = await UserService.recoverUsername(this.email)
        this.$notificationService.success(this.$t('EmailSent').toString())
        this.$router.push('/login')
      } catch (error: any) {
        this.errorHandlerService.handle(this, error.response.data.code, true)
      } finally {
        this.isPending = false
      }
    }
    this.isPending = false
  }

  private cancel() {
    this.$router.push('/login')
  }
}
